'use client'

import Script from 'next/script'

const VSSStylesScript = () => {
  return (
    <Script id='vss-updates'>{`window.__VSS_UPDATES__ = ${JSON.stringify({
      buttonEnabled: false,
      toastEnabled: true,
    })}`}</Script>
  )
}

export default VSSStylesScript
